export default __webpack_public_path__ + "static/media/Chevron.07b787c0.svg";